import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// import { CSSTransitionGroup } from '@/ui/ReactTransitionGroup'

// Importing raw component (theme will be passed from here)
import Button from '@/ui/Button/Button'
import NavLink from '@/ui/NavLink'
import TriangleIcon from '@/icons/TriangleRight'

const Breadcrumb = props => {
  const getPath = (path, map) => {
    const paths = []
    let curr = path
    let route = map[curr]

    while (curr) {
      paths.unshift({ obj: route, type: curr })
      curr = route.parent
      route = curr && map[curr]
    }
    return paths
  }
  const { routesMap, route, theme, goToPage } = props
  const segments = getPath(route, routesMap)

  return (
    <div className={theme.breadcrumb}>
      <div>
        <For each="segment" index="indx" of={segments}>
          <Choose>
            <When condition={segments.length > 1 && indx !== segments.length - 1}>
              <NavLink
                key={segment.obj.name}
                tag="div"
                className={classNames(theme['breadcrumb-item'], theme['breadcrumb-active'])}
                to={{ type: segment.type }}
                {...segment.obj.resource && {
                  includeQuery: segment.obj.resource,
                }}
                {...segment.obj.path === '/' && { exact: 'exact' }}
              >
                {segment.obj.name}
              </NavLink>
            </When>
            <Otherwise>
              <div key={segment.obj.name} className={classNames(theme['breadcrumb-item'])}>
                {indx !== 0 && <TriangleIcon size=".6em" />}
                {segment.obj.name}
              </div>
            </Otherwise>
          </Choose>
        </For>
        <If condition={routesMap[route].action}>
          <div className={classNames(theme['breadcrumb-item'], theme['breadcrumb-actions'])}>
            <Button
              classes="secondary"
              theme={theme}
              onClick={() => goToPage(routesMap[route].action.target)}
            >
              {routesMap[route].action.label}
            </Button>
          </div>
        </If>
      </div>
    </div>
  )
}

Breadcrumb.propTypes = {
  theme: PropTypes.object.isRequired,
  routesMap: PropTypes.object.isRequired,
}

export default Breadcrumb



// WEBPACK FOOTER //
// ./ui/Breadcrumb/Breadcrumbs.js